import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { ModalComponent } from '@tecalisdev/infinity';

@Component({
	selector: 'app-modal-json-viewer',
	imports: [NgxJsonViewerModule, ModalComponent, TranslatePipe],
	templateUrl: './modal-json-viewer.component.html',
	styleUrl: './modal-json-viewer.component.scss',
})
export class ModalJsonViewerComponent {
	@Input() title: string;
	@Input() json: unknown;
	@Output() closeEvent = new EventEmitter<boolean>();

	protected copyFeedback = signal(false);

	protected closeModal(type: string): void {
		if (type === 'buttonPrimary') {
			this.copyToClipboard();
			return;
		}
		this.closeEvent.emit(false);
	}

	private copyToClipboard(): void {
		if (this.json === undefined || this.json === null) {
			return;
		}
		const text = JSON.stringify(this.json, null, 2);
		void navigator.clipboard.writeText(text).then(
			() => this.showCopiedFeedback(),
			() => this.fallbackCopy(text),
		);
	}

	private fallbackCopy(text: string): void {
		const ta = document.createElement('textarea');
		ta.value = text;
		ta.setAttribute('readonly', '');
		ta.style.position = 'absolute';
		ta.style.left = '-9999px';
		document.body.appendChild(ta);
		ta.select();
		try {
			document.execCommand('copy');
			this.showCopiedFeedback();
		} finally {
			document.body.removeChild(ta);
		}
	}

	private showCopiedFeedback(): void {
		this.copyFeedback.set(true);
		window.setTimeout(() => this.copyFeedback.set(false), 2000);
	}
}
